var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { MaskedNumericInput, } from '../../../atoms/MaskedNumericInput';
import FieldBox from '../../../../uikit/fields/FieldBox';
import { withFormikField } from '../../../../hoc/withFormikField';
export var MaskedNumericInputField = function (props) {
    var name = props.name, label = props.label, isOptional = props.isOptional, description = props.description, _a = props.errors, errors = _a === void 0 ? [] : _a, inputProps = __rest(props, ["name", "label", "isOptional", "description", "errors"]);
    var error = errors && errors.length ? errors[0] : undefined;
    return (React.createElement(FieldBox, { name: name, label: label, isOptional: isOptional, description: description, error: error },
        React.createElement(MaskedNumericInput, __assign({ name: name }, inputProps))));
};
export var MaskedNumericInputFormikField = withFormikField(MaskedNumericInputField);
